import {
    Injectable
} from '@angular/core';

import {
    NgbModal
} from '@ng-bootstrap/ng-bootstrap';

import { InstitutionAuditReportComponent } from './institution-audit-report.component';

/*
* Service to view the institution audit-report modal.
*/
@Injectable()
export class ViewInstitutionAuditReportComponentService {

    constructor(
        private modalService: NgbModal
    ) {
        //
    }

    openComponent(institutionKey: number) {
        const modalRef = this.modalService.open(InstitutionAuditReportComponent, { size: 'lg' });
        modalRef.componentInstance.institutionKey = institutionKey;
    }
}
